<template>
  <div>
    <v-list-item>
      <v-list-item-action>
        <v-checkbox
          v-model="modelChecked"
          @change="toggleChecked"
          v-if="!loading"
        />

        <v-progress-circular
          indeterminate
          :size="20"
          color="primary"
          v-if="loading"
        ></v-progress-circular>
      </v-list-item-action>

      <v-list-item-content>
        <v-list-item-title>{{ permission.name }}</v-list-item-title>
        <v-list-item-subtitle>{{ permission.description }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import permissionsApi from '../../services/permissions.api';

export default {
  props: {
    roleId: {
      type: Number,
      value: null,
    },
    permission: {
      type: Object,
      value: () => ({})
    },
    checked: {
      type: Boolean,
      value: false,
    },
  },
  data: () => ({
    modelChecked: false,
    loading: false,
  }),
  methods: {
    ...mapActions("whizeosupportToolsStore", ["SHOW_SNACKBAR"]),
    async toggleChecked() {
      if (this.modelChecked) {
        await this.assignPermission();
      } else {
        await this.unassignPermission();
      }
    },

    async assignPermission() {
      this.loading = true;

      try {
        await permissionsApi.assignPermissionRole(this.permission.permissionId, this.roleId);
      } catch (error) {
        
        const errorMessage = {
          visible: true,
          color: "error",
          message:
            "There was a problem while applying permission to user role.",
        };

        this.SHOW_SNACKBAR(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    async unassignPermission() {
      this.loading = true;

      try {
        await permissionsApi.unassignPermissionRole(this.permission.permissionId, this.roleId);
      } catch (error) {
        const errorMessage = {
          visible: true,
          color: "error",
          message:
            "There was a problem while applying permission to user role.",
        };

        this.SHOW_SNACKBAR(errorMessage);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.modelChecked = this.checked;
  },
};
</script>